import { customerHelper } from '@tweddle-se-team/common/constants'
import { generalHelpers } from '@tweddle-se-team/common/helpers'
import { determineSpecificOrigin } from '@/utils/specificOriginHelper'
import { productActions } from '../products'
import { searchActions } from '../search'
import { configsActions } from '../configs'
import startCase from 'lodash/startCase'
import { customerId } from '@/utils/env'

const { BRANDS_BY_CUSTOMER } = customerHelper
const DEFAULT_BRAND = BRANDS_BY_CUSTOMER[customerId][0]

/**
 * This helper function initializes the brand based on the provided origin and brand.
 * It dispatches the necessary actions to the store to set the brand.
 * If no brand is specified, it defaults to "toyota".
 * It also handles specific origins that may override the brand because depending on
 * the origin (domain) we can't switch brands.
 * Additionally, only on the browser it sets the brand if not defined as the main
 * site can select the brand manually from the Navigation Bar.
 * @param {*} store
 * @returns
 */
const initializeBrand =
  store =>
  (origin = null, brand = null) => {
    const {
      search: {
        query: { filterBy }
      },
      configs: { customerId }
    } = store.getState()
    const selectedBrand = filterBy?.brand || ''

    // Determine specific origin brand and domain
    // Priority order:
    // 1. Customer ID defined by the application environment variables.
    // 1.1 If only one brand is available for the customer, use that brand.
    // 1.2 If multiple brands are available for the customer, check the origin (domain).
    // 2. Specific origin brand (if any) based on the origin (domain).
    const customerBrands = BRANDS_BY_CUSTOMER[customerId]
    const [domainBrand, domain] = determineSpecificOrigin(origin)
    const specificOriginBrand = customerBrands?.length === 1 ? customerBrands[0] : domainBrand
    const specificDomain = domain || origin

    const changeBrand = brand => {
      if (customerBrands.includes(brand) && selectedBrand.toLowerCase() !== brand) {
        store.dispatch(productActions.SET_BRAND(startCase(brand)))
        store.dispatch(searchActions.SET_BRAND(startCase(brand)))
      }
    }
    const setShowStaticLogo = showStaticLogo => store.dispatch(configsActions.SET_SHOW_STATIC_LOGO(showStaticLogo))

    const setSpecificDomain = domain => store.dispatch(configsActions.SET_SPECIFIC_DOMAIN(domain))

    if (specificOriginBrand && specificOriginBrand !== selectedBrand.toLowerCase()) {
      // Specific origin has priority over brand in query params
      changeBrand(specificOriginBrand)
      // Also, showing static specific brand logo
      setShowStaticLogo(true)
      // Set specific origin domain
      setSpecificDomain(specificDomain)
      return specificOriginBrand
    } else if (brand && brand !== selectedBrand.toLowerCase()) {
      changeBrand(brand.toLowerCase())
      return brand.toLowerCase()
    }

    // This should only happen in the browser since the action to change the brand
    // is only visible client-side. Otherwise the brand is overriden by the server-side
    // dispatched actions.
    if (generalHelpers.isServer() && !brand && !selectedBrand) {
      changeBrand(DEFAULT_BRAND)
      return DEFAULT_BRAND
    }
    return selectedBrand
  }

const brandHelpers = {
  initializeBrand
}

export default brandHelpers
